import { Link } from 'react-router-dom';
import { ScheduleIcon } from '@icons';
import { useMemo } from 'react';
import { NotificationType, SchedulerNotificationData } from '@/api/apis/communication';
import { getColorsByOrganType } from '@/utils/helpers';
import { formatCreatedAt, getBodyForSchedulerNotificationType, getSchedulerPath } from '../config';
import { OrganType } from '@/api/apis/case';

export const SchedulerNotification = ({
  notification,
}: {
  notification: NotificationType<SchedulerNotificationData>;
}) => {
  const { category, heading, createdAt, data } = notification;
  const colors = getColorsByOrganType(category as OrganType);
  const createAtTime = useMemo(() => formatCreatedAt(createdAt), [createdAt]);

  return (
    <Link
      to={getSchedulerPath(data) || '/schedule'}
      className="h-[85px] w-[776px] p-3 bg-white rounded-lg shadow items-start gap-2 inline-flex justify-between"
    >
      <div className="flex flex-row gap-2 justify-start">
        <div className={`${colors.bg40} w-5 h-5 rounded-2xl flex items-center justify-center`}>
          <ScheduleIcon className="h-4 w-4" />
        </div>
        <div className={`flex flex-col gap-2 justify-between pl-1 ${colors.textSaturated}`}>
          <span className="text-xs-sb">{heading}</span>
          {data && getBodyForSchedulerNotificationType(data, createAtTime)}
        </div>
      </div>
      <div className="flex items-end shrink-0">
        <span className="text-xs-r text-base-20">{createAtTime}</span>
      </div>
    </Link>
  );
};
